import DOMPurify from "dompurify"

const config = {
  ALLOWED_TAGS: ['span'], // Inclua outras tags que você deseja permitir
}

export const sanitize = (conteudo) => {
  return DOMPurify.sanitize(conteudo, config)
}
